module.exports = __webpack_public_path__ + "storm_configuration-31191a7e65abd231ae08589c72b6701b.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/storm_configuration.png
// module id = km9F
// module chunks = client